import { useEffect } from "react"
import { isMobile } from "../Hero";
function SideNavTest({items}){
    const changeCrypto = (name) => {
        const foundCrypto = items.find(x => x.item === name);
        if(foundCrypto.item === 'Ethereum'){
            console.log("etereum found")
            foundCrypto.link("ethereum");
            sessionStorage.setItem("crypto", "ethereum");
        }
        else{
            foundCrypto.link(name);
            sessionStorage.setItem("crypto", "bitcoin");
        }
    }
    useEffect(()=>{

    },[])
    return(
        <div id="mySidebar" style={{fontSize:"10px",zIndex:100}} class="sidebar">
        <a style={{fontSize :isMobile()? "12px": "25px"}} href="/" class="closebtn" onclick="closeNav()">&times;</a>
        <a style={{fontSize :isMobile()? "12px": "25px"}} href="/">About</a>
        <a style={{fontSize :isMobile()? "12px": "25px"}} href="/">Services</a>
        <a style={{fontSize :isMobile()? "12px": "25px"}} href="/">Clients</a>
        <a style={{fontSize :isMobile()? "12px": "25px"}} href="/">Contact</a>
        </div>

    )
} 

export default SideNavTest